class ReadMore extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.textElement = this.querySelector('.mrk-read-more-text');
    this.button = this.querySelector('.mrk-read-more-button');
    console.log(this,this.button);

    this.buttonText = this.button.querySelector('.mrk-secondar-text');
    this.isExpanded = false;
    this.readMoreText = this.buttonText.dataset.showMore;
    this.readLessText = this.buttonText.dataset.showLess;

    this.button.addEventListener('click', () => {
        this.isExpanded = !this.isExpanded;
        
        if (this.isExpanded) {
        this.textElement.classList.remove('collapsed');
        this.buttonText.textContent = this.readLessText;
        } else {
        this.textElement.classList.add('collapsed');
        this.buttonText.textContent = this.readMoreText;
        }
    });
    }
}

customElements.define('read-more', ReadMore);